import { cn } from "@/lib/utils";

/** Neutral placeholder block. Pulses (unless reduced motion); never a spinner. */
export function Skeleton({ className }: { className?: string }) {
	return <div aria-hidden="true" className={cn("rounded-md bg-raised animate-skeleton", className)} />;
}

/** Visually-hidden live text for screen readers. */
export function SrOnly({ children }: { children: React.ReactNode }) {
	return <span className="sr-only">{children}</span>;
}

export const button = {
	primary:
		"inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-signal px-[18px] text-sm font-bold text-on-signal transition-colors hover:bg-signal-hover disabled:opacity-60 cursor-pointer",
	secondary:
		"inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-line-2 bg-raised px-4 text-[13px] font-semibold text-ink transition-colors hover:border-line-3 disabled:opacity-60 cursor-pointer",
	ghost:
		"inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-line-2 bg-transparent px-[18px] text-sm font-semibold text-ink transition-colors hover:bg-raised cursor-pointer"
};

export const label = "text-[11px] font-semibold uppercase tracking-[.09em] text-ink-3";
